<template>
	<el-container class="project">
		<el-aside width="180px">
			<nav-menu></nav-menu>
		</el-aside>
		<el-main class="content">
			<el-card class="screen-box">
				<el-form ref="form" :model="searchForm" :inline="true" size="small">
					<el-form-item label="项目名称:">
						<el-input placeholder="请输入项目名称" v-model="searchForm.name"></el-input>
					</el-form-item>
					<el-form-item>
						<el-button @click="search()" icon="el-icon-search" type="primary" size="small">查询</el-button>
						<el-button @click="resetForm()" icon="el-icon-delete" size="small">清空</el-button>
						<el-button @click="add()" icon="el-icon-plus" type="primary" size="small">添加收费项目</el-button>
					</el-form-item>
				</el-form>
			</el-card>
			<el-card class="table-box">
				<el-table :data="tableList" id="table" border>
					<template v-for="(item, index) in tableLabel">
						<el-table-column :key="index" :prop="item.prop" :label="item.label" :formatter="item.formatter">
						</el-table-column>
					</template>
					<el-table-column label="操作" width="160">
						<template slot-scope="scope">
							<el-button type="text" size="mini" @click="qrCodeGeneration(scope.row)">二维码</el-button>
							<el-button type="text" size="mini" @click="edit(scope.row)">编辑</el-button>
							<el-popconfirm title="您确定要删除吗？" @confirm="del(scope.row)">
								<el-button type="text" size="mini" slot="reference" style="margin-left:5px;">删除</el-button>
							</el-popconfirm>
						</template>
					</el-table-column>
				</el-table>
				<el-pagination @size-change="handleSizeChange" @current-change="handleCurrentChange" :current-page="searchForm.page" :page-sizes="pageSizes" :page-size="searchForm.limit" layout="total, sizes, prev, pager, next, jumper" :total="totalCount"></el-pagination>
			</el-card>
		</el-main>
		<!-- 弹出层 -->
		<el-dialog :title="dialogTitle" :visible.sync="dialogFormVisible">
			<el-form :model="form" label-width="100px" size="small">
				<el-form-item label="项目名称">
					<el-input placeholder="请输入项目名称" v-model="form.name"></el-input>
				</el-form-item>
				<el-form-item label="价格(元)">
					<el-input placeholder="请输入价格(元)" v-model="form.amount"></el-input>
				</el-form-item>
				<el-form-item label="推送有效时间">
					<el-date-picker type="datetime" placeholder="推送有效时间" v-model="form.expiredTime" value-format="yyyy-MM-dd HH:mm:ss"></el-date-picker>
				</el-form-item>
				<el-form-item label="项目描述">
					<el-input type="textarea" placeholder="请输入项目描述" v-model="form.content"></el-input>
				</el-form-item>
			</el-form>
			<div slot="footer" class="dialog-footer">
				<el-button @click="dialogFormVisible = false" size="small">取 消</el-button>
				<el-button type="primary" @click="formSubmit()" size="small">确 定</el-button>
			</div>
		</el-dialog>
		<!-- 二维码 -->
		<el-dialog title="二维码" :visible.sync="qrCodeVisible" width="28%" >
            <div id="qrCodeUrl"></div>
            <div slot="footer" class="dialog-footer">
                <el-button @click="qrCodeVisible = false">取消</el-button>
            </div>
        </el-dialog>
	</el-container>
</template>

<script>
	import QRCode from 'qrcodejs2';
	import { projectPageApi,projectDeleteApi,projectSaveApi,projectUpdateApi } from "@/axios/api";
	export default {
		name: "Project",
		data() {
			return {
				totalCount:0,
				pageSizes:[10],
				searchForm:{
					isSearchCount:true,
					page:1,
					limit:10,
					name:''
				},
				tableList: [],
				tableLabel: [{
					label: "项目名称",
					prop: "name"
				}, {
					label: "价格(元)",
					prop: "amount",
					formatter: (row) => {
						return (row.amount/100).toFixed(2);
					}
				}, {
					label: "创建时间",
					prop: "createTime"
				}, {
					label: "推送有效时间",
					prop: "expiredTime"
				}],
				dialogFormVisible: false,
				dialogTitle:'添加收费项目',
				form: {
					name:'',
					amount:'',
					content:'',
					expiredTime:'',
					schoolId:''
				},
				openType:'',
				qrCodeVisible:false
			}
		},
		created(){
			this.form.schoolId = localStorage.getItem("schoolId");
			this.getData();
		},
		methods:{
			getData(){
				projectPageApi(this.searchForm).then((res) => {
					if (res.code == 200){
						this.tableList = res.data.records;
						this.totalCount = res.data.total;
					}
				}).catch((err) => {});
			},
			//查询
			search(){
				this.searchForm.page = 1;
				this.getData();
			},
			//清空
			resetForm(){
				this.searchForm.name = '';
				this.searchForm.page = 1;
				this.getData();
			},
			//生成二维码
			qrCodeGeneration(row){
				this.qrCodeVisible = true;
				this.$nextTick(function () {
					document.getElementById("qrCodeUrl").innerHTML = "";// 防止一直点击按钮重复生成二维码
					let qrCodeUrl = new QRCode('qrCodeUrl', {
						width: 200, // 二维码宽度，单位像素
						height: 200, // 二维码高度，单位像素
						text: this.global.apiUrl + '/mp/authorization_url?projectId=' + row.id, // 生成二维码的链接
					})
				})
			},
			//添加
			add(){
				this.form = {
					name:'',
					amount:'',
					content:'',
					expiredTime:'',
					schoolId:''
				};
				this.openType = 'add';
				this.dialogTitle = '添加收费项目';
				this.dialogFormVisible = true;
			},
			//编辑
			edit(row){
				this.form = {
					name:row.name,
					amount:row.amount/100,
					content:row.content,
					expiredTime:row.expiredTime,
					schoolId:row.schoolId,
					id:row.id
				};
				this.openType = 'edit';
				this.dialogTitle = '编辑收费项目';
				this.dialogFormVisible = true;
			},
			formSubmit(){
				this.form.amount = this.form.amount * 100;
				if(this.openType == 'edit'){
					projectUpdateApi(this.form).then((res) => {
						if (res.code == 200){
							this.$message.success("编辑成功");
							this.dialogFormVisible = false;
							this.getData();
						}
					}).catch((err) => {});
				}else{
					projectSaveApi(this.form).then((res) => {
						if (res.code == 200){
							this.$message.success("添加成功");
							this.dialogFormVisible = false;
							this.resetForm();
						}
					}).catch((err) => {});
				}
			},
			//删除
			del(row){
				projectDeleteApi({id:row.id}).then((res) => {
					if (res.code == 200){
						this.$message.success("删除成功");
						this.getData();
					}
				}).catch((err) => {});
			},
			// 分页
			handleSizeChange(val) {
				this.searchForm.limit=val // 改变每页显示的条数 
				this.searchForm.page=1 // 注意：在改变每页显示的条数时，要将页码显示到第一页
				this.getData() // 点击每页显示的条数时，显示第一页
			},
			handleCurrentChange(val) {
				this.searchForm.page=val // 改变默认的页数
				this.getData() // 切换页码时，要获取每页显示的条数
			}
		}
	}
</script>

<style lang="less" scoped>
	.screen-box{
		margin-left: 12px;
	}
	.table-box{
		margin-left: 12px;
		min-height: 83vh;
	}
	/deep/ #qrCodeUrl > img {
        margin: 0 auto;
    }
</style>